import styled from '@emotion/styled';

export const ComboboxRoot = styled.div<{
  $focused: boolean;
  $open?: boolean;
  $disabled?: boolean;
}>`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 8px 40px 8px 8px;
  background: ${({ $disabled }) => ($disabled ? 'var(--dk-bg-subtle, #F9FAFB)' : 'var(--dk-bg, #FFFFFF)')};
  /* 외곽선은 inset — border 로 높이(44px)가 늘어나지 않게 */
  box-shadow: inset 0 0 0 1px
    ${({ $focused, $open, $disabled }) =>
      $disabled ? '#E7E9EC' : $focused || $open ? '#000000' : '#E7E9EC'};
  border-radius: 8px;
  transition: box-shadow 120ms ease;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'text')};
`;

export const InputRow = styled.div`
  display: flex;
  flex: 1 1 120px;
  min-width: 120px;
  align-items: center;
  gap: 8px;
`;

export const Caret = styled.button<{ $open: boolean }>`
  position: absolute;
  top: 10px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--dk-text-strong, #637381);
  cursor: pointer;
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 120ms ease;
`;

export const InlineInput = styled.input`
  flex: 1 1 auto;
  min-width: 80px;
  border: none;
  outline: none;
  background: transparent;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: var(--dk-text, #212b36);
  padding: 0 0 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;

  &::placeholder {
    color: var(--dk-text-dim, #b7bbc2);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
